import { useSyncExternalStore } from 'react';
import { getIqUiSnapshot, subscribeIqUi } from '../../state/iqUiStore.ts';
import { IQ_DOM } from './iqDomIds.ts';
import { useI18n } from 'shared/lib/i18n.tsx';

export function IqPause() {
  const d = IQ_DOM;
  const { t } = useI18n();
  const s = useSyncExternalStore(subscribeIqUi, getIqUiSnapshot, getIqUiSnapshot);

  return (
    <div
      id={d.pauseRoot}
      className="iq-pause"
      hidden={!s.pauseVisible}
      role="dialog"
      aria-modal="true"
    >
      <div className="iq-pause__panel">
        <h2 className="iq-pause__title">{t('game.pause')}</h2>
        <div className="iq-pause__score">{s.score}</div>
      </div>
    </div>
  );
}
